import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import clsx from 'clsx';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Scrollbar from '../../commons/Scrollbar';
import useTest from '../../hooks/useTest';
import { publicLogoPath } from '../../utils/constants';
import { getFromLS } from '../../utils/utils';
import style from './style';
import Button from '@material-ui/core/Button';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import floor from 'lodash/floor';

const LayoutLinearBar = ({ children, isGradient, noPadding }: any) => {
  const history = useHistory();
  const cls = style();
  const user = JSON.parse(getFromLS('userInfos') || '{}');

  const mainLink = user?.role?.id === 3 ? '/results' : '/main';

  const { progress } = useTest();

  return (
    <div className={cls.layout}>
      <div
        className={clsx(
          cls.content,
          isGradient ? cls.gradientBG : null,
          noPadding ? cls.noPadding : null
        )}>
        <AppBar position="sticky" color="transparent" elevation={0} className={cls.appBar}>

          <nav className={cls.navbar}>
            <div style={{ display: 'flex', alignItems: 'center', width: '100%', flexWrap: 'nowrap', overflow: 'hidden' }}>
              <div
                className={cls.logoContainer}
                onClick={() => (user ? history.push(mainLink) : history.push('/'))}>
                <picture className={cls.logo}>
                  <source
                    media="(min-width:650px)"
                    srcSet={`${publicLogoPath}/e-orientaction.png`}
                  />
                  <img
                    style={{ width: '100%' }}
                    src={`${publicLogoPath}/e-orientaction.png`}
                    alt="logo-orientation"
                  />
                </picture>
              </div>

              <div style={{ display: 'flex', alignItems: 'center', flex: '1', minWidth: '100px', maxWidth: '400px', marginLeft: '20px', marginRight: '20px' }}>
                <div style={{ width: '100%', minWidth: 0 }}>
                  <LinearProgress
                    classes={{
                      colorPrimary: cls.colorPrimary,
                      barColorPrimary: cls.barColorPrimary,
                    }}
                    variant="determinate"
                    value={progress}
                  />
                </div>
                <p style={{ marginLeft: '8px', whiteSpace: 'nowrap', flexShrink: 0 }}>{floor(progress)}%</p>
              </div>

              <Hidden only={['xs', 'sm']}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexShrink: 0, marginLeft: 'auto' }}>
                  <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap', gap: '8px' }}>
                    <PhoneIcon style={{ fontSize: '18px', flexShrink: 0 }} />
                    <div style={{ textAlign: 'left', lineHeight: 1.2 }}>
                      <div style={{ whiteSpace: 'nowrap' }}>02 43 72 25 88*</div>
                      <div style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                        *Numéro national non surtaxé
                      </div>
                    </div>
                  </div>
                  <Button className={cls.btnContacter} onClick={() => window.open("https://www.orientaction-groupe.com/contact/", "_blank")}>
                    <MailOutlineIcon style={{ fontSize: '18px' }} />
                    <span style={{ textAlign: 'left', lineHeight: 1.2, marginLeft: 10 }}>
                      <div>Nous</div>
                      <div>Contacter</div>
                    </span>
                  </Button>
                </div>
              </Hidden>

              <Hidden only={['xl', 'lg', 'md']}>
                <IconButton className={cls.btnIcon} onClick={() => history.push('/user/tests')} style={{ marginLeft: 'auto' }}>
                  <ClearIcon className={cls.styleIcon} />
                </IconButton>
              </Hidden>
            </div>
          </nav>
        </AppBar>
        <Scrollbar style={{ padding: 0 }}>{children}</Scrollbar>
      </div>
    </div>
  );
};

export default LayoutLinearBar;
